import { boolean, defineAction, enumerated, object, string } from '~/prix'
import fampeAttendedEntitiesImportAction from './fampeAttendedEntitiesImport.action.json'

const fampeAttendedEntitiesImportDefinition = defineAction({
  ...fampeAttendedEntitiesImportAction,
  input: object({
    file: string().isOptional(),
    step: enumerated({
      fetchUploadUrl: 'fetchUploadUrl',
      importFile: 'importFile',
    }),
    contentType: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default fampeAttendedEntitiesImportDefinition
